export default __webpack_public_path__ + "static/media/caleb-calendar-icon.a97f50db.svg";